import React from 'react';
import { MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-slate-200 bg-white px-4 pb-28 pt-12 md:pb-12" data-id="element-100" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-4xl text-center" data-id="element-101" data-mp="3gh3swj7aaeh9">
        <p className="text-lg font-black uppercase tracking-tight text-slate-900" data-id="element-102" data-mp="32p5mig4yiwos">
          🔨 Muebles Fáciles en Casa
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-103" data-mp="36nd75m2jki59">
          Proyectos de carpintería doméstica para construir muebles, organizadores y accesorios para
          distintos sectores de tu hogar.
        </p>
        <p className="mt-2 text-sm font-semibold text-slate-500" data-id="element-104" data-mp="36d26u3xsnlq">
          Medidas, piezas, listas de cortes y armado paso a paso dentro del mismo sistema.
        </p>
        <p className="mt-6 text-sm font-black uppercase tracking-wide text-sky-700" data-id="element-105" data-mp="3qbvo5gde8p8v">
          Compra Digital Ya™
        </p>
        <div className="mt-3 flex justify-center text-sm font-semibold text-slate-600" data-id="element-106" data-mp="2a1jlnfn4665m">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-sky-700" href="mailto:compradigitalyaa@gmail.com" data-id="element-107" data-mp="2ew6yuico3e4w">
            <MailIcon className="h-4 w-4" data-id="element-108" data-mp="3gcaa3ffvofh0" /> compradigitalyaa@gmail.com
          </a>
        </div>
        <div className="mt-7 border-t border-slate-200 pt-6" data-id="element-109" data-mp="3v91ans1afx87">
          <p className="text-base font-black uppercase text-slate-900" data-id="element-110" data-mp="3q7lo1vjgpinp">
            50 proyectos para transformar espacios de tu casa con tus propias manos.
          </p>
          <p className="mt-5 text-xs font-semibold text-slate-400" data-id="element-111" data-mp="3473nkkfm3xo">
            © Compra Digital Ya™ 2026 — Todos los derechos reservados.
            <br data-id="element-112" data-mp="hrigrqw9hvzw" />
            Prohibida la reproducción, copia, reventa o redistribución total o parcial del contenido
            sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}